import {
  BoelsPointOfServiceStock,
  GeoPoint,
  PointOfServiceStock,
  SearchConfig,
} from '@boels/models';
import { createAction, props } from '@ngrx/store';

export const findProductStock = createAction(
  '[ProductStock] Find Stores with Stock',
  props<{
    productCodes: string[];
    queryText: string;
    searchConfig: SearchConfig;
    longitudeLatitude?: GeoPoint;
  }>(),
);

export const findProductStockSuccess = createAction(
  '[ProductStock] Find Stores with Stock Success',
  props<{ stores: PointOfServiceStock[] }>(),
);

export const findProductStockFailure = createAction(
  '[ProductStock] Find Stores with Stock Failure',
  props<{ errorMessage: string }>(),
);

export const setSelectedProductStock = createAction(
  '[ProductStock] Set Selected Product Stock',
  props<{ query: string; selectedProductStock: BoelsPointOfServiceStock }>(),
);

export const resetSelectedProductStock = createAction(
  '[ProductStock] Reset Selected Product Stock',
);
